import axios from 'axios'
import { APIS } from './config';
import _ from 'lodash'
const findProductsExpositorById = (product, allProduct) => {
    const productExpositors = JSON.parse(product.product.ProductosExpositor);
    let productsInExpositor = []
    for (let i = 0; i < productExpositors.length; i++) {
        const product = productExpositors[i];
        if (product.RefSuelto.indexOf('$') > -1) {
            const productExpositor = _.filter(allProduct, productList => {
                return productList.RefSuelto.trim() === product.RefSuelto.trim()
            })[0]
            const productQuantity = { product: productExpositor, quantity: product.Quantity }
            productsInExpositor.push(productQuantity)
        }
    }
    return productsInExpositor;
}

export const sendBudget = (data) => {
    return new Promise((resolve, reject) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${data.tokenUser}`
            }
        };
        let productsBudget = []
        for (let i = 0; i < data.budget.length; i++) {
            const product = data.budget[i];
            if (product.format === 'expositor') {
                const productsExpositor = findProductsExpositorById(product, data.allProducts)
                productsBudget.push(product)
                for (let a = 0; a < productsExpositor.length; a++) {
                    const productExpositor = productsExpositor[a];
                    const productValues = {
                        product: productExpositor.product,
                        quantity: productExpositor.quantity * product.total,
                        format: 'expositor',
                        total: productExpositor.quantity * product.total,
                    }
                    productsBudget.push(productValues)
                }
            } else {
                productsBudget.push(product)
            }
        }
        axios.post(`${APIS['fansa']}/protected/budget`, {
            company: data.userBudget.empresa,
            cif: data.userBudget.cif,
            name: data.userBudget.name,
            phonenumber: data.userBudget.phonenumber,
            zone: data.userBudget.zone,
            location: data.userBudget.location,
            email: data.userBudget.email,
            role: data.userBudget.role,
            comments: data.userBudget.comments,
            products: JSON.stringify(productsBudget),
            brand: data.brand
        }, headers).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        });
    })
}

export const saveBudget = (data) => {
    return new Promise((resolve, reject) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${data.tokenUser}`
            }
        };
        axios.post(`${APIS['fansa']}/protected/cart`, {
            company: data.userBudget.empresa,
            cif: data.userBudget.cif,
            name: data.userBudget.name,
            phonenumber: data.userBudget.phonenumber,
            zone: data.userBudget.zone,
            email: data.userBudget.email,
            role: data.userBudget.role,
            location: data.location,
            products: JSON.stringify(data.budget),
            brand: data.brand
        }, headers).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        });
    })
}